module.exports = __webpack_public_path__ + "img/CardImage1.9fce0858.png";